// @flow

import React, {Fragment, useState} from 'react';

import {PopoverBody} from 'reactstrap';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {
  AttachOverlay,
  AttachOverlayChildProps,
  OverlayPlacementType,
  PopoverForm,
} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {useCreateRole} from 'app/roles/api';
import {gt} from 'app/utils/i18n';

import type {TeamSerializedType} from 'sweet-types';

interface Props {
  team: TeamSerializedType;
  placement?: OverlayPlacementType;
  children?: (handlers: AttachOverlayChildProps) => JSX.Element;
}

export function AddNewTeamRoleButton({
  team,
  placement = 'left',
  children,
}: Props) {
  // RTK API Hooks
  const [createRole] = useCreateRole();

  // States
  const [name, setName] = useState<string>('');

  const addRoleToTeam = () => {
    createRole({team, name});
  };

  return (
    <AttachOverlay
      trigger="click"
      overlay={({overlayProps}) => (
        <PopoverForm overlayProps={{...overlayProps, placement}}>
          {({close, closeOnSuccess}) => (
            <Fragment>
              <PopoverBody>
                <input
                  placeholder={gt('Role Name')}
                  autoFocus={true}
                  value={name}
                  className="form-control"
                  onChange={(e) => setName(e.target.value)}
                  type={'text'}
                />
              </PopoverBody>
              <StyledPopoverBottomDIV>
                <button className="btn btn-sm btn-link" onClick={close}>
                  {gt('Close')}
                </button>
                <StateButton
                  isIdle={true}
                  onClick={() => closeOnSuccess(addRoleToTeam())}
                  className="btn btn-sm btn-primary"
                  busyText={gt('Confirm')}
                >
                  {gt('Confirm')}
                </StateButton>
              </StyledPopoverBottomDIV>
            </Fragment>
          )}
        </PopoverForm>
      )}
    >
      {(handlers) =>
        children != null ? (
          children(handlers)
        ) : (
          <button className="btn btn-light" {...handlers}>
            <i className="fas fa-plus-circle mr-1" />
            {gt('Role')}
          </button>
        )
      }
    </AttachOverlay>
  );
}
